// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Screen C — favourites list */
.FavouriteStations {
  padding-inline: 20px;
  position: relative;
}
.FavouriteStations__Header {
  display: flex;
  align-items: center;
  padding-block: 3rem;
  gap: 16px;
}
.FavouriteStations__Left {
  display: block;
}
.FavouriteStations__Title {
  color: #1e1e1e;
  font-family: "Syne", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.36px;
}
.FavouriteStations__Input {
  padding: 20px 0px;
}
.FavouriteStations__FilterContainer {
  display: flex;
  gap: 8px;
  border: none;
  margin-bottom: 25px;
  overflow-x: scroll;
}
.FavouriteStations__FilterContainer .filter-btn {
  white-space: nowrap;
}
.FavouriteStations__Cards {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.FavouriteStations__Loader {
  display: flex;
  justify-content: center;
  align-items: center;
}
.FavouriteStations__Empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  text-align: center;
}
.FavouriteStations__EmptyTitle {
  color: #1e1e1e;
  font-family: "Outfit", sans-serif;
  font-size: 16px;
  font-weight: 600;
}
.FavouriteStations__EmptyText {
  color: #8c8c8c;
  font-family: "Outfit", sans-serif;
  font-size: 13px;
  font-weight: 300;
  margin-bottom: 12px;
}
.FavouriteStations__Error {
  color: #ec6a5e;
  font-family: "Outfit", sans-serif;
  font-size: 13px;
  text-align: center;
  padding-top: 12px;
}

/* Screen A — dashboard card */
.FavouriteCard {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1.5rem;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #f2f2f2;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 170, 116, 0.08);
  cursor: pointer;
}
.FavouriteCard__Icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #e6f7ef;
}
.FavouriteCard__Content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.FavouriteCard__Title {
  color: #1e1e1e;
  font-family: "Outfit", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.FavouriteCard__SubTitle {
  color: #8c8c8c;
  font-family: "Outfit", sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: normal;
}
.FavouriteCard__Link {
  color: #00aa74;
  font-family: "Outfit", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
}
.FavouriteCard__Add {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  outline: none;
  border-radius: 50%;
  background: #00aa74;
  cursor: pointer;
}
.FavouriteCard__Skeleton {
  display: block;
  width: 60%;
  height: 12px;
  margin-top: 6px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f2f2f2 25%, #e9e9e9 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: FavouriteCard__shimmer 1.2s ease-in-out infinite;
}

@keyframes FavouriteCard__shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/FavouriteStationsView/FavouriteStations.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,+BAAA;AACA;EACI,oBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAAR;AAEI;EACI,cAAA;AAAR;AAEI;EACI,cCIU;EDHV,+BCmBI;EDlBJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AAEI;EACI,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAGI;EACI,cCrCU;EDsCV,iCCrBS;EDsBT,eAAA;EACA,gBAAA;AADR;AAGI;EACI,cClDS;EDmDT,iCC3BS;ED4BT,eAAA;EACA,gBAAA;EACA,mBAAA;AADR;AAGI;EACI,cC7DO;ED8DP,iCClCS;EDmCT,eAAA;EACA,kBAAA;EACA,iBAAA;AADR;;AAKA,8BAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oDAAA;EACA,eAAA;AAFJ;AAII;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBClGQ;ADgGhB;AAKI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAHR;AAMI;EACI,cC3FU;ED4FV,iCC3ES;ED4ET,eAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAOI;EACI,cC1GS;ED2GT,iCCnFS;EDoFT,eAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAQI;EACI,cC/HQ;EDgIR,iCC3FS;ED4FT,eAAA;EACA,gBAAA;EACA,mBAAA;AANR;AASI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBCjJQ;EDkJR,eAAA;AAPR;AAUI;EACI,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yEAAA;EAMA,0BAAA;EACA,2DAAA;AAbR;;AAiBA;EACI;IACI,6BAAA;EAdN;EAgBE;IACI,0BAAA;EAdN;AACF","sourcesContent":["@import '../../../Styles/sass/variables';\n\n/* Screen C — favourites list */\n.FavouriteStations {\n    padding-inline: 20px;\n    position: relative;\n\n    &__Header {\n        display: flex;\n        align-items: center;\n        padding-block: 3rem;\n        gap: 16px;\n    }\n    &__Left {\n        display: block;\n    }\n    &__Title {\n        color: $color_black_300;\n        font-family: $main_font;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.36px;\n    }\n    &__Input {\n        padding: 20px 0px;\n    }\n    &__FilterContainer {\n        display: flex;\n        gap: 8px;\n        border: none;\n        margin-bottom: 25px;\n        overflow-x: scroll;\n\n        .filter-btn {\n            white-space: nowrap;\n        }\n    }\n    &__Cards {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n    }\n    &__Loader {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    &__Empty {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n        padding: 32px 16px;\n        text-align: center;\n    }\n    &__EmptyTitle {\n        color: $color_black_300;\n        font-family: $secondary_font;\n        font-size: 16px;\n        font-weight: 600;\n    }\n    &__EmptyText {\n        color: $color_grey_400;\n        font-family: $secondary_font;\n        font-size: 13px;\n        font-weight: 300;\n        margin-bottom: 12px;\n    }\n    &__Error {\n        color: $semantic_red;\n        font-family: $secondary_font;\n        font-size: 13px;\n        text-align: center;\n        padding-top: 12px;\n    }\n}\n\n/* Screen A — dashboard card */\n.FavouriteCard {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 1.5rem;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid $color_grey_100;\n    background: #ffffff;\n    box-shadow: 0px 4px 12px 0px rgba(0, 170, 116, 0.08);\n    cursor: pointer;\n\n    &__Icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 44px;\n        height: 44px;\n        border-radius: 50%;\n        background: $primary_light;\n    }\n\n    &__Content {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n        flex: 1;\n        min-width: 0;\n    }\n\n    &__Title {\n        color: $color_black_300;\n        font-family: $secondary_font;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: normal;\n    }\n\n    &__SubTitle {\n        color: $color_grey_400;\n        font-family: $secondary_font;\n        font-size: 13px;\n        font-weight: 300;\n        line-height: normal;\n    }\n\n    &__Link {\n        color: $primary_green;\n        font-family: $secondary_font;\n        font-size: 13px;\n        font-weight: 500;\n        line-height: normal;\n    }\n\n    &__Add {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 32px;\n        height: 32px;\n        padding: 0;\n        border: none;\n        outline: none;\n        border-radius: 50%;\n        background: $primary_green;\n        cursor: pointer;\n    }\n\n    &__Skeleton {\n        display: block;\n        width: 60%;\n        height: 12px;\n        margin-top: 6px;\n        border-radius: 6px;\n        background: linear-gradient(\n            90deg,\n            $color_grey_100 25%,\n            #e9e9e9 37%,\n            $color_grey_100 63%\n        );\n        background-size: 400% 100%;\n        animation: FavouriteCard__shimmer 1.2s ease-in-out infinite;\n    }\n}\n\n@keyframes FavouriteCard__shimmer {\n    0% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0 50%;\n    }\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
